export const PROJECT_REQUEST_FORMS_CONFIG = {
    name            : 'Requests & Forms',
    icon            : 'i5-request-forms',
    // iconLight       : 'i5-request-forms',
    iconSvg         : 'isvg-forms',
    // image           : 'request-forms',
    // url             : 'request-forms',
    // stringId        : 'request-forms',
    // description     : 'View and manage request forms.',
    menuName        : 'Forms',
    inheritance     : false,
}
